import { AccountService } from "../services";

const extractBuildingId = (params) => {
  if (!params) return undefined;
  if (typeof params === "number") return params;
  if (typeof params === "object") {
    if (typeof params.buildingId === "number") return params.buildingId;
    if (typeof params.buildingId === "object") return params.buildingId?.id;
    if (typeof params.id === "number") return params.id;
  }
  return undefined;
};

export const account = {
  state: () => ({
    accounts: [],
    selectedAccounts: [],
    current: null,
  }),
  mutations: {
    setAccounts: (state, value) => (state.accounts = value || []),
    setSelectedAccounts: (state, value) => (state.selectedAccounts = value || []),
    setCurrentAccount: (state, value) => (state.current = value || null),
  },
  actions: {
    ACCOUNT_FIND_ALL: async ({ commit }, params) => {
      const response = await AccountService.findAll(params || {});
      if (response.ok) {
        commit("setAccounts", response.data || []);
      } else {
        alert(response.message || "No fue posible obtener las cuentas contables");
      }
      return response;
    },
    ACCOUNT_FIND_ONE: async ({ commit }, id) => {
      const response = await AccountService.findById(id);
      if (response.ok) {
        commit("setCurrentAccount", response.data || null);
      } else {
        alert(response.message || "No fue posible obtener la cuenta contable");
      }
      return response;
    },
    ACCOUNT_CREATE: async ({ dispatch }, payload) => {
      const response = await AccountService.create(payload);
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("ACCOUNT_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    ACCOUNT_UPDATE: async ({ dispatch }, { id, ...payload }) => {
      const response = await AccountService.update({ id, ...payload });
      if (response.ok) {
        const buildingId = extractBuildingId(payload?.buildingId ?? payload);
        if (buildingId) {
          await dispatch("ACCOUNT_FIND_ALL", { buildingId });
        }
      }
      return response;
    },
    ACCOUNT_DELETE: async ({ dispatch }, { id, buildingId }) => {
      const response = await AccountService.remove(id);
      if (response.ok) {
        const resolvedBuildingId = extractBuildingId(buildingId);
        if (resolvedBuildingId) {
          await dispatch("ACCOUNT_FIND_ALL", { buildingId: resolvedBuildingId });
        }
      }
      return response;
    },
    ACCOUNT_NEXT_CODE: async (_, params) => AccountService.nextCode(params),
    ACCOUNT_DOWNLOAD_EXCEL: async (_, payload) => AccountService.downloadExcel(payload),
  },
  getters: {
    accountById: (state) => (id) => state.accounts.find((item) => item.id === id) || null,
  },
};

